import { Select } from 'antd';
import { omit } from 'lodash';
import useHttpClient from 'hooks/useHttpClient';
import { useQuery } from '@tanstack/react-query';
import { masterDataKeys } from 'features/lost-found-management/keys';
import { appApiMasterIndices } from 'configs/variables';

const { Option } = Select;

export function SpSelectItemType(props) {
  const { data, isLoading } = useSpSelectItemType();

  return (
    <Select
      {...props}
      showSearch
      labelInValue
      loading={isLoading}
      placeholder="เลือกประเภทไอเท็ม"
      onChange={(value, option) => {
        props?.onChange?.(value, option);
        const selectedType = data?.find((ss) => ss.id === value.value);

        if (selectedType) {
          const x = {
            ...selectedType,
            ...omit(value, ['disabled', 'title']),
          };

          props?.onChange?.(x, option);
        }
      }}
    >
      {data?.map((ss, index) => (
        <Option key={index} value={ss.id}>
          {ss.label_en}
        </Option>
      ))}
    </Select>
  );
}

export function useSpSelectItemType() {
  const { get } = useHttpClient();
  const queryRequest = useQuery({
    queryKey: masterDataKeys.selectCategory.queryKey,
    queryFn: async () =>
      await get({
        url: `${appApiMasterIndices}/lost_and_found/category`,
      }),
    select: (res) => {
      const { response } = res;
      return response?.data || undefined;
    },
  });

  return queryRequest;
}
